module.exports = __webpack_public_path__ + "img/04-min.d88f013a.jpg";